var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7de8f47600eb668ddb79000a396bb2b7784dfc07"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nx_customers@smartmonkeyio"]={id:"7de8f47600eb668ddb79000a396bb2b7784dfc07"};
      